/**
 * Apartsales — `cn` utility.
 *
 * Standard pattern: `clsx` for conditional class composition + `twMerge`
 * to dedupe conflicting Tailwind classes (e.g. `p-2 p-4` → `p-4`).
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
